export const BADGE_COLOR_MAPPING = {
  2: {
    color: 'success',
    text: 'dashboard.http_status.ok',
  },
  4: {
    color: 'warning',
    text: 'dashboard.http_status.error',
  },
  5: {
    color: 'critical',
    text: 'dashboard.http_status.error',
  },
}

export const ELMO_EXPERIMENTS = {
  UpgradeHub: {
    Treatment: 'Trmt_developer_upgrade_hub_v2',
  },
}
export const NEW_USER = 'newuser'
export const EXISTING_USER = 'existinguser'
